<template>
  <div :class="componentClasses" class="p-4 mb-4 text-sm rounded-lg" role="alert">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Alert',

  props: {
    type: String,
    link: String,
  },

  computed: {
    componentClasses() {
      let type = this.type
      if( type === 'danger' ) type = 'red'
      if( type === 'success' ) type = 'green'
      if( type === 'warning' ) type = 'orange'
      if( type === 'info' ) type = 'secondary'
      return `text-${type}-700 bg-${type}-100`
    },
  },
}
</script>

<style scoped>

</style>